<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
  <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'cities'; scope: 'cities'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.countryId')}}</nz-form-label>
          <nz-form-control>
            <hx-country-select formControlName="countryId"></hx-country-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.order')}}</nz-form-label>
          <nz-form-control>
            <input nz-input type="number" formControlName="order" min="1"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>Slug</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="slug"/>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8" *ngIf="isEdit">
      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{ 'cities.form.deliveryMinOrderPrice' | transloco: {currency: currencySymbol} }}</nz-form-label>
          <nz-form-control [nzExtra]="'cities.form.deliveryMinOrderPriceHint' | transloco">
            <nz-input-number formControlName="deliveryMinOrderPrice" [nzMin]="0" [nzStep]="500" [nzPlaceHolder]="'cities.form.deliveryMinOrderPricePlaceholder' | transloco"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
